export default {"src":"/_next/static/media/required.50d7aa77.svg","height":4,"width":5};